{
  $(document).on('click', '.metodology-list-subhead', function() {
	if ( $(this).hasClass("metodology-list-arrow_down") ) { 
	  $(this).removeClass('metodology-list-arrow_down').addClass('metodology-list-arrow_up'); 
	}
	else {
	  $(this).removeClass('metodology-list-arrow_up').addClass('metodology-list-arrow_down');
	}
    $(this).next('ul').toggle();
  })
}